
export const createGame = (settings, callback) => {
  return (dispatch, getState, {getFirebase}) => {
    const firebase = getFirebase();
    const authorId = getState().firebase.auth.uid;
    const timestamp = firebase.firestore().tu.firebase_.firestore.FieldValue.serverTimestamp();
    firebase.firestore().collection('games').add({
      authorId: authorId,
      settings: settings,
      createdAt: timestamp
    }).then(() => {
      dispatch({ type: 'CREATE_GAME_SUCCESS' });
    }).catch(err => {
      dispatch({ type: 'CREATE_GAME_ERROR' }, console.log(err));
    });
  }
};

export const updatePlayers = (id, settings) => {
    return (dispatch, getState, {getFirebase}) => {
    const firebase = getFirebase();
    const userId = getState().firebase.auth.uid;
    const timestamp = firebase.firestore().tu.firebase_.firestore.FieldValue.serverTimestamp();
    const gameRef = firebase.firestore().collection('games/').doc(id);
      gameRef.update({
        settings: settings,
        timestamp: timestamp
      }).then(() => {
      dispatch({ type: 'UPDATE_PLAYERS_SUCCESS' });
      }).catch(err => {
      dispatch({ type: 'UPDATE_PLAYERS_ERROR' }, console.log(err));
      });
  }
};

export const updateRoundOne = (id, roundOneChoices, callback) => {
    return (dispatch, getState, {getFirebase}) => {
    const firebase = getFirebase();
    const userId = getState().firebase.auth.uid;
    const timestamp = firebase.firestore().tu.firebase_.firestore.FieldValue.serverTimestamp();
    const gameRef = firebase.firestore().collection('games/').doc(id);
      gameRef.update({
        roundOneChoices: roundOneChoices,
        timestamp: timestamp
      }).then(() => {
      callback();
      dispatch({ type: 'UPDATE_ROUNDONE_SUCCESS' });
      }).catch(err => {
      dispatch({ type: 'UPDATE_ROUNDONE_ERROR' }, console.log(err));
      });
  }
};

export const updateThisRound = (id, thisRoundBye, round, thisRoundChoices, callback) => {
    return (dispatch, getState, {getFirebase}) => {
    const firebase = getFirebase();
    const userId = getState().firebase.auth.uid;
    const timestamp = firebase.firestore().tu.firebase_.firestore.FieldValue.serverTimestamp();
    const gameRef = firebase.firestore().collection('games/').doc(id);
    const path = "round"+round+"Choices";
    const byePath = 'round'+round+'Bye';
      gameRef.update({
        [path]: thisRoundChoices,
        [byePath]: thisRoundBye,
        timestamp: timestamp
      }).then(() => {
      callback();
      dispatch({ type: 'UPDATE_ROUND_SUCCESS' });
      }).catch(err => {
      dispatch({ type: 'UPDATE_ROUND_ERROR' }, console.log(err));
      });
  }
};

export const updateWinners = (id, winners, callback) => {
    return (dispatch, getState, {getFirebase}) => {
    const firebase = getFirebase();
    const userId = getState().firebase.auth.uid;
    const timestamp = firebase.firestore().tu.firebase_.firestore.FieldValue.serverTimestamp();
    const gameRef = firebase.firestore().collection('games/').doc(id);
      gameRef.update({
        winners: winners,
        timestamp: timestamp
      }).then(() => {
      callback();
      dispatch({ type: 'UPDATE_WINNERS_SUCCESS' });
      }).catch(err => {
      dispatch({ type: 'UPDATE_WINNERS_ERROR' }, console.log(err));
      });
  }
};

export const updateWinnersRound = (id, winners, round, callback) => {
    return (dispatch, getState, {getFirebase}) => {
    const firebase = getFirebase();
    const userId = getState().firebase.auth.uid;
    const timestamp = firebase.firestore().tu.firebase_.firestore.FieldValue.serverTimestamp();
    const gameRef = firebase.firestore().collection('games/').doc(id);
      gameRef.update({
        winners: winners,
        timestamp: timestamp
      }).then(() => {
      callback();
      dispatch({ type: 'UPDATE_WINNERSROUND_SUCCESS' });
      }).catch(err => {
      dispatch({ type: 'UPDATE_WINNERSROUND_ERROR' }, console.log(err));
      });
  }
};

export const updateRound = (id, round, callback) => {
    return (dispatch, getState, {getFirebase}) => {
    const firebase = getFirebase();
    const userId = getState().firebase.auth.uid;
    const timestamp = firebase.firestore().tu.firebase_.firestore.FieldValue.serverTimestamp();
    const gameRef = firebase.firestore().collection('games/').doc(id);
      gameRef.update({
        round: round,
        timestamp: timestamp
      }).then(() => {
      callback();
      dispatch({ type: 'UPDATE_ROUND_SUCCESS' });
      }).catch(err => {
      dispatch({ type: 'UPDATE_ROUND_ERROR' }, console.log(err));
      });
  }
};

export const updateWinnersList = (id, winnersPath, winners, callback) => {
    return (dispatch, getState, {getFirebase}) => {
    const firebase = getFirebase();
    const userId = getState().firebase.auth.uid;
    const timestamp = firebase.firestore().tu.firebase_.firestore.FieldValue.serverTimestamp();
    const gameRef = firebase.firestore().collection('games/').doc(id);
    let path = winnersPath;
    //console.log('path');
    //console.log(path);
      gameRef.update({
        [path]: winners,
        timestamp: timestamp
      }).then(() => {
      callback();
      dispatch({ type: 'UPDATE_WINNERSLIST_SUCCESS' });
      }).catch(err => {
      dispatch({ type: 'UPDATE_WINNERSLIST_ERROR' }, console.log(err));
      });
  }
};

export const updateVote = (gameId, match, choice) => {
    return (dispatch, getState, {getFirebase}) => {
    const firebase = getFirebase();
    const userId = getState().firebase.auth.uid;
    const timestamp = firebase.firestore().tu.firebase_.firestore.FieldValue.serverTimestamp();
    const gameRef = firebase.firestore().collection('games/').doc(gameId);
    const path = "roundOneChoices."+match+"."+userId;
      gameRef.update({
        [path]: choice,
        timestamp: timestamp
      }).then(() => {
      //callback();
      dispatch({ type: 'UPDATE_VOTE_SUCCESS' });
      }).catch(err => {
      dispatch({ type: 'UPDATE_VOTE_ERROR' }, console.log(err));
      });
  }
};

export const updateVoteRound = (gameId, match, choice, round) => {
    return (dispatch, getState, {getFirebase}) => {
    const firebase = getFirebase();
    const userId = getState().firebase.auth.uid;
    const timestamp = firebase.firestore().tu.firebase_.firestore.FieldValue.serverTimestamp();
    const gameRef = firebase.firestore().collection('games/').doc(gameId);
    const path = "round"+(round)+"Choices."+match+"."+userId;
      gameRef.update({
        [path]: choice,
        timestamp: timestamp
      }).then(() => {
      //callback();
      dispatch({ type: 'UPDATE_VOTEROUND_SUCCESS' });
      }).catch(err => {
      dispatch({ type: 'UPDATE_VOTEROUND_ERROR' }, console.log(err));
      });
  }
};



export const createChoices = (id, playerChoices) => {
    return (dispatch, getState, {getFirebase}) => {
    const firebase = getFirebase();
    const userId = getState().firebase.auth.uid;
    const timestamp = firebase.firestore().tu.firebase_.firestore.FieldValue.serverTimestamp();
    const gameRef = firebase.firestore().collection('games/').doc(id);
      gameRef.update({
        timestamp: timestamp,
        playerChoices: playerChoices
      }).then(() => {
      dispatch({ type: 'UPDATE_CREATECHOICES_SUCCESS' });
      }).catch(err => {
      dispatch({ type: 'UPDATE_CREATECHOICES_ERROR' }, console.log(err));
      });
  }
};

export const backupGame = (game) => {
  return (dispatch, getState, {getFirebase}) => {
    const firebase = getFirebase();
    const timestamp = firebase.firestore().tu.firebase_.firestore.FieldValue.serverTimestamp();
    firebase.firestore().collection('deletedGames').add({
      ...game,
      deletedAt: timestamp
    }).then(() => {
      dispatch({ type: 'BACKUP_GAME_SUCCESS' });
    }).catch(err => {
      dispatch({ type: 'BACKUP_GAME_ERROR' }, err);
    });
  }
};

export const deleteGame = (id, callback) => {
  return (dispatch, getState, {getFirebase}) => {
    const firebase = getFirebase();
    firebase.firestore().collection('games').doc(id).delete().then(() => {
      if(callback){callback()}
      dispatch({ type: 'DELETE_GAME_SUCCESS' });
    }).catch(err => {
      dispatch({ type: 'DELETE_GAME_ERROR' }, err);
      console.log(err);
    });
  }
};